import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

// Icons
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ScheduleIcon from "@mui/icons-material/Schedule";
import RateReviewIcon from "@mui/icons-material/RateReview";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const FeatureSection = () => {
  return (
    <Box sx={{ py: 6, px: 4, maxWidth: 1200, mx: "auto" }}>
      <Grid container spacing={4}>
        {/* Left Section */}
        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h3"
              component="h1"
              sx={{ fontWeight: "bold", color: "#006A71" }}
            >
              Streamline <span style={{ color: "#033538" }}>Interview</span>
            </Typography>
            <Typography
              variant="h3"
              component="h1"
              sx={{ fontWeight: "bold", color: "#006A71", mb: 3 }}
            >
              Lifecycle Management
            </Typography>

            <Box 
              sx={{ 
                p: 3, 
                mb: 4, 
                borderRadius: 2, 
                background: 'linear-gradient(145deg, #f0f9fa 0%, #e6f7f8 100%)',
                border: '1px solid #d0eaec',
                boxShadow: '0 4px 12px rgba(0, 106, 113, 0.08)'
              }}
            >
              <Typography
                variant="h5"
                sx={{ 
                  mb: 2, 
                  fontWeight: 600, 
                  color: "#006A71",
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <EmojiEventsIcon sx={{ mr: 1 }} /> Our Goal
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: "1.1rem", color: "#033538", fontWeight: 500 }}
              >
                To simplify and streamline the entire interview lifecycle—from scheduling to feedback—into a single, user-friendly system that boosts productivity and collaboration.
              </Typography>
            </Box>

            <Box 
              sx={{ 
                p: 3, 
                mb: 4, 
                borderRadius: 2, 
                background: 'linear-gradient(145deg, #e6f7f8 0%, #d0eaec 100%)',
                border: '1px solid #c0dfe2',
                boxShadow: '0 4px 12px rgba(0, 106, 113, 0.12)'
              }}
            >
              <Typography
                variant="h5"
                sx={{ 
                  mb: 2, 
                  fontWeight: 600, 
                  color: "#033538",
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <AssessmentIcon sx={{ mr: 1 }} /> Our Vision
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: "1.1rem", color: "#006A71", fontWeight: 500 }}
              >
                To empower organizations with a transparent, organized, and efficient interview process that enhances candidate experience and improves hiring outcomes.
              </Typography>
            </Box>

            {/* <Typography
              variant="body1"
              sx={{ mb: 4, fontSize: "1.1rem", color: "black" }}
            >
              With AI Disha admin app, enhance your interview process with:
            </Typography>

            <List sx={{ mb: 4 }}>
              {[
                "End-to-end interview scheduling and management",
                "Collaborative feedback collection and assessment",
                "Automated candidate communications and updates",
                "Comprehensive analytics and hiring insights",
                "Seamless integration with existing HR systems",
              ].map((text, index) => (
                <ListItem key={index} sx={{ py: 1 }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckCircleOutlineIcon sx={{ color: "#3b82f6" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={text}
                    primaryTypographyProps={{
                      sx: {
                        color: "black !important",
                        fontWeight: 400,
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List> */}

            <Button
              variant="contained"
              size="large"
              sx={{
                borderRadius: 28,
                px: 4,
                py: 1.5,
                textTransform: "none",
                fontSize: "1.1rem",
                fontWeight: "bold",
                bgcolor: "#006A71",
                "&:hover": {
                  bgcolor: "#033538",
                },
              }}
            >
              Start Free Trial Now
            </Button>
          </Box>
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Box sx={{ position: "relative", width: "100%", maxWidth: "500px" }}>
              <img
                src="/assests/images/interviewcycle.png"
                alt="Interview Lifecycle"
                style={{ 
                  width: "100%", 
                  height: "auto",
                  borderRadius: "12px",
                  boxShadow: "0 12px 24px rgba(0, 106, 113, 0.15)"
                }}
              />
              
              
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeatureSection;